import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { Smartphone, Apple, Play } from 'lucide-react';
import { getMobilePlatform } from '@/utils/mobile-detection';

/**
 * Component that displays a message directing mobile users to download the mobile app
 * Shows appropriate app store links based on the device platform
 */
export function MobileAppRedirect() {
  const { t } = useTranslation('pages.login');
  const platform = getMobilePlatform();


  // App Store URLs - these should be updated with actual app store links when available
  const APP_STORE_URL = 'https://apps.apple.com/app/folw/id6757766016'; // Replace with actual App Store URL
  //TODO: Update with actual Play Store URL
  //const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=eu.folw.app'; // Replace with actual Play Store URL
  const PLAY_STORE_URL  = 'https://play.google.com/store/apps/details?id=folw.eu'; // Replace with actual Play Store URL
  

  return (
    <div className="auth-page">
      <Card className="w-full max-w-md relative card-container-muted card-container-no-shadow card-container-border-black">
        <CardHeader className="text-center pb-6 pt-8">
          <div className="flex flex-col items-center justify-center mb-4">
            <img 
              src="/images/icons/SquareLogo.svg" 
              alt="FOLW Logo" 
              className="h-16 w-16 mb-3"
            />
            <img 
              src="/images/logos/FolwLogoText.svg" 
              alt="FOLW" 
              className="h-8"
            />
          </div>
        </CardHeader>
        <CardContent className="px-8 pb-8">
          <div className="flex flex-col items-center text-center space-y-6">
            <div className="flex items-center justify-center w-20 h-20 rounded-full bg-blue-100">
              <Smartphone className="h-10 w-10 text-blue-600" />
            </div>
            
            <div className="space-y-2">
              <h2 className="text-xl font-semibold text-gray-900">
                {t('mobileApp.title')}
              </h2>
              <p className="text-sm text-gray-600">
                {t('mobileApp.message')}
              </p>
            </div>

            <div className="w-full space-y-3">
              {platform === 'ios' && (
                <Button
                  asChild
                  className="w-full"
                  size="lg"
                >
                  <a
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2"
                  >
                    <Apple className="h-5 w-5" />
                    {t('mobileApp.downloadIOS')}
                  </a>
                </Button>
              )}

              {platform === 'android' && (
                <Button
                  asChild
                  className="w-full"
                  size="lg"
                >
                  <a
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2"
                  >
                    <Play className="h-5 w-5" />
                    {t('mobileApp.downloadAndroid')}
                  </a>
                </Button>
              )}

              {(platform === null || !platform) && (
                <>
                  <Button
                    asChild
                    className="w-full"
                    size="lg"
                  >
                    <a
                      href={APP_STORE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2"
                    >
                      <Apple className="h-5 w-5" />
                      {t('mobileApp.downloadIOS')}
                    </a>
                  </Button>
                  <Button
                    asChild
                    variant="outline"
                    className="w-full"
                    size="lg"
                  >
                    <a
                      href={PLAY_STORE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2"
                    >
                      <Play className="h-5 w-5" />
                      {t('mobileApp.downloadAndroid')}
                    </a>
                  </Button>
                </>
              )}
            </div>

            <p className="text-xs text-gray-500">
              {t('mobileApp.footer')}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
